// axios 拦截器
import axios from 'axios'
import store from "@/store";
import {Message} from 'element-ui'
import {errorCode} from '@/utils/global'
import router from "@/router"
axios.defaults.baseURL = '/api'

// 返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  const isToken = (config.headers || {}).isToken === false
  let token =  store.getters.access_token
  if (token && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + token// token
  }
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// HTTPresponse拦截
axios.interceptors.response.use(res => {
  const status = Number(res.status) || 200
  const message = res.data.msg || errorCode[status] || errorCode['default']
  if (status === 401) {
    store.dispatch('fedLogOut').then(() => {
      router.push({path: '/login'})
    })
    return
  }
  if (status !== 200 || res.data.code === 1) {
    Message({
      message: message,
      type: 'error'
    })
    return Promise.reject(new Error(message))
  }
  return res
}, error => {
  return Promise.reject(new Error(error))
})

// 上传文件
function uploadFile(file, dic) {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('dic', dic)
  return new Promise((resolve, reject) => {
    axios({
      url: '/sys/file/upload',
      method: 'post',
      data: formData
    }).then(res => {
      let {
        code,
        data,
        msg
      } = res.data
      if (code === 0) {
        resolve(data)
      } else {
        Message.error(msg)
        reject()
      }
    })
  })
}

export default {
  uploadFile
}



// WEBPACK FOOTER //
// ./src/api/index.js